<template>
  <v-dialog :value="value" @input="close" max-width="600px">
    <v-card>
      <!-- Title -->
      <v-card-title>
        <h3 v-if="item">{{ $t("projects-impact.mainDialog.edit.title") }}</h3>
        <h3 v-else>{{ $t("projects-impact.mainDialog.add.title") }}</h3>
      </v-card-title>

      <v-card-text>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <!-- Type -->
            <v-col cols="12" class="mt-12">
              <v-select
                :label="$t('projects-impact.labels.type')"
                outlined
                hide-details
                v-model="form.type"
                :rules="requiredRules"
                :items="$t('constants.projectsImpactTypes.list')"
                item-text="text"
                item-value="value"
              />
            </v-col>

            <!-- Name -->
            <v-col cols="12">
              <v-text-field
                outlined
                :rules="requiredRules"
                :label="$t('projects-impact.labels.name')"
                maxlength="100"
                hide-details
                v-model="form.name"
              />
            </v-col>

            <!-- FM Referent -->
            <v-col cols="12">
              <SelectFMReferent
                :is-required="true"
                :value="form.fm_referent"
                @input="onInputFMReferent"
              />
            </v-col>

            <!-- Account -->
            <v-col cols="12">
              <SelectAccount
                :is-required="true"
                account-type="BRAND"
                :value="form.account"
                @input="onInputAccount"
              />
            </v-col>

            <!-- Known Suppliers -->
            <v-col cols="12" class="mt-12">
              <v-text-field
                outlined
                type="number"
                :rules="requiredRules"
                :label="$t('projects-impact.labels.knownSuppliers')"
                maxlength="100"
                hide-details
                v-model="form.knownSuppliers"
              />
            </v-col>

            <!-- State -->
            <v-col cols="12">
              <v-select
                :label="$t('projects-impact.labels.state')"
                outlined
                hide-details
                v-model="form.state"
                :items="$t('constants.projectsImpactStates.list')"
                item-text="text"
                item-value="value"
              />
            </v-col>

            <v-col cols="12">
              <v-alert
                v-if="form.state === 'DONE'"
                shaped
                type="warning"
                dismissible
              >
                {{ $t("projects-impact.alerts.mf-to-reviewed") }}
              </v-alert>
            </v-col>

            <v-col cols="12">
              <AlertBar />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <ButtonBarFormDialog
          class="mx-3"
          :is-loading-btn-save="isLoadingBtn.btnSave"
          @submit="customSubmit"
          @cancel="close"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dialogMixin from "@/mixins/dialog";
import formRules from "@/mixins/formRules";

export default {
  name: "ProjectImpactMainDialog",

  mixins: [dialogMixin, formRules],

  components: {
    SelectAccount: () => import("@/components/Common/Inputs/SelectAccount"),
    SelectFMReferent: () =>
      import("@/components/Common/Inputs/SelectFMReferent"),
    AlertBar: () => import("@/components/Common/Bars/AlertBar"),
    ButtonBarFormDialog: () =>
      import("@/components/Common/Buttons/ButtonBarFormDialog"),
  },

  data() {
    return {
      isLoadingBtn: { btnSave: false },

      defaultForm: {
        name: "",
        fm_referent: {
          id: this.$session.get("id"),
          person: this.$session.get("person"),
        },
        account: null,
        knownSuppliers: 0,
        type: "STANDARD",
        state: "PLANNED",
      },
    };
  },

  methods: {
    customSubmit() {
      if (this.$refs.form.validate()) {
        this.isLoadingBtn.btnSave = true;

        if (this.form.fm_referent && this.form.fm_referent.id)
          this.form.fm_referent = this.form.fm_referent.id;
        if (this.form.account && this.form.account.id)
          this.form.account = this.form.account.id;

        this.form.knownSuppliers = Number(this.form.knownSuppliers);
        if (this.item) this.submitEdit();
        else this.submitAdd();
      }
    },

    submitAdd() {
      this.$http
        .post(`/projects-impact`, this.form, {
          headers: { Authorization: "Bearer " + this.$session.get("jwt") },
        })
        .then((res) => {
          this.$store.commit(
            "toast/showSuccess",
            this.$t("projects-impact.mainDialog.add.success")
          );
          this.close(true);
        })
        .catch((err) => {
          this.$store.commit("alert/showErrorAxios", err);
        })
        .finally(() => {
          this.isLoadingBtn.btnSave = false;
        });
    },

    submitEdit() {
      this.$http
        .put(`/projects-impact/${this.item.id}`, this.form, {
          headers: { Authorization: "Bearer " + this.$session.get("jwt") },
        })
        .then((res) => {
          this.$store.commit(
            "toast/showSuccess",
            this.$t("projects-impact.mainDialog.edit.success")
          );
          this.close(true);
        })
        .catch((err) => {
          this.$store.commit("alert/showErrorAxios", err);
        })
        .finally(() => {
          this.isLoadingBtn.btnSave = false;
        });
    },

    onInputAccount(val) {
      if (val && val.id) this.form.account = val.id;
      else this.form.account = val;
    },

    onInputFMReferent(val) {
      this.form.fm_referent = val;
    },
  },
};
</script>

<style scoped></style>
